'use client';

import type { RepairRequestReason } from '@/lib/service/repairRequestState';

import styles from './RepairRequestReasonSummary.module.scss';

interface RepairRequestReasonSummaryProps {
  reasons: RepairRequestReason[];
  reasonComment: string;
}

export function RepairRequestReasonSummary({
  reasons,
  reasonComment,
}: Readonly<RepairRequestReasonSummaryProps>) {
  return (
    <div className={styles.wrapper} data-testid="review-reason-summary">
      <ul className={styles.list}>
        {reasons.map((reason) => (
          <li key={reason.value}>{reason.label}</li>
        ))}
      </ul>
      {reasonComment.trim() ? <p className={styles.comment}>{reasonComment}</p> : null}
    </div>
  );
}
